import { render, staticRenderFns } from "./admins.vue?vue&type=template&id=ee76d4c2&scoped=true&"
import script from "./admins.vue?vue&type=script&lang=js&"
export * from "./admins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee76d4c2",
  null
  
)

export default component.exports